module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row pt-1 pb-1 pr-1 partnership-block"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_vm._v("Условия сотрудничеста")]), _vm._v(" "), _c('div', {
    staticClass: "col-8 form-group"
  }, [_c('div', {
    staticClass: "row pb-1"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("От установки")]), _vm._v(" "), _c('div', {
    staticClass: "input-group col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partnership.commissionInstall),
      expression: "partnership.commissionInstall"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.partnership.commissionInstall)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partnership, "commissionInstall", $event.target.value)
      }, function($event) {
        _vm.changePartnership()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          %\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row pb-1"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("От рекламации")]), _vm._v(" "), _c('div', {
    staticClass: "input-group col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partnership.commissionReclamation),
      expression: "partnership.commissionReclamation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.partnership.commissionReclamation)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partnership, "commissionReclamation", $event.target.value)
      }, function($event) {
        _vm.changePartnership()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          %\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_vm._v("От продажи в розницу")]), _vm._v(" "), _c('div', {
    staticClass: "input-group col-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.partnership.commissionRetail),
      expression: "partnership.commissionRetail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.partnership.commissionRetail)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.partnership, "commissionRetail", $event.target.value)
      }, function($event) {
        _vm.changePartnership()
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          %\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/production/shared/frontend/~/vue-loader/lib/template-compiler?{"id":"data-v-1a0204f6"}!/home/alarmplan/production/shared/frontend/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Techcenter/components/TcPartnership.vue
// module id = 1000
// module chunks = 1